export default __webpack_public_path__ + "static/media/internalbleed4.11ba9f92.png";